import { useFieldArray, useFormContext } from 'react-hook-form'

import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { Col2x, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

import { ProductInstrumentDescription } from './ProductInstrumentDescription'

export const ProductInstrumentDescriptionList = () => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `suspiciousActivityInfo.productInstrumentDesc`
  })

  return (
    <>
      <FormRow>
        <Col2x>
          <h5>48. Product/Instrument description (if needed)</h5>
        </Col2x>
      </FormRow>
      {fields.map((field, index) => (
        <ProductInstrumentDescription key={field.id} index={index} rowsNumber={fields.length} onDelete={remove} />
      ))}
      <FormRow>
        <IconButton face="positive" icon={IconName.ADD_GREEN} onClick={() => append({ value: '' })} />
      </FormRow>
    </>
  )
}
